(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };

      if (!this.elements.button || !this.elements.input || !this.elements.panel) return;

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString(),
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('#header-sticky');
      if (!this.header) return;

      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        return;
      }

      this.sentinel = document.querySelector('#sentinel');
      if (!this.sentinel) return;

      this.currentScrollTop = 0;
      this.isScrolled = false;

      // Two thresholds derived from the header's own geometry create a
      // hysteresis band so scrolling back and forth across the breakpoint no
      // longer flip-flops the sticky state:
      //   engageOffset   = scroll pos where the header has fully scrolled off
      //   disengageOffset = scroll pos where the header's natural top is back
      //                     at the viewport top (== the pinned top:0 position)
      // Because both transitions happen where the pinned and in-flow positions
      // coincide, any residual toggle at the edge is visually seamless too.
      this.measure();

      this.throttledOnScroll = this.throttle(this.onScroll.bind(this), 100);
      this.onResize = this.measure.bind(this);

      window.addEventListener('scroll', this.throttledOnScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });

      if ('ResizeObserver' in window) {
        this.headerResizeObserver = new ResizeObserver(() => this.measure());
        this.headerResizeObserver.observe(this.header);
      }

      // Set the correct state if the page loads already scrolled.
      this.onScroll();
    }

    disconnectedCallback() {
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
      window.removeEventListener('scroll', this.throttledOnScroll);
      window.removeEventListener('resize', this.onResize);
    }

    measure() {
      // #sentinel sits directly below #header-sticky and is never made sticky,
      // so its offsetTop is a stable anchor even while the header is pinned.
      this.engageOffset = this.sentinel.offsetTop;
      this.disengageOffset = this.engageOffset - this.header.offsetHeight;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (!this.isScrolled) {
        if (scrollTop >= this.engageOffset) {
          // Header has fully scrolled off — pin it (hidden) ready to reveal on
          // the next upward scroll.
          this.isScrolled = true;
          this.header.classList.add('is-scrolled', 'shopify-section-header-sticky', 'shopify-section-header-hidden');
          this.currentScrollTop = scrollTop;
        }
        return;
      }

      if (scrollTop <= this.disengageOffset) {
        // Natural position has caught up with the pinned position — release the
        // header back into flow with no visible jump.
        this.isScrolled = false;
        this.header.classList.remove(
          'is-scrolled',
          'shopify-section-header-sticky',
          'shopify-section-header-hidden',
          'animate',
        );
        this.currentScrollTop = scrollTop < 0 ? 0 : scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop) {
        // Scrolling down
        this.header.classList.add('shopify-section-header-hidden');
      } else {
        // Scrolling up
        this.header.classList.add('animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      this.currentScrollTop = scrollTop < 0 ? 0 : scrollTop;
    }

    throttle(fn, wait) {
      let inThrottle, lastFn, lastTime;
      return function () {
        const context = this,
          args = arguments;
        if (!inThrottle) {
          fn.apply(context, args);
          lastTime = Date.now();
          inThrottle = true;
        } else {
          clearTimeout(lastFn);
          lastFn = setTimeout(
            function () {
              if (Date.now() - lastTime >= wait) {
                fn.apply(context, args);
                lastTime = Date.now();
              }
            },
            Math.max(wait - (Date.now() - lastTime), 0),
          );
        }
      };
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const base_url = this.dataset.url
      this.url = base_url

      if(!base_url.includes("product_id")){
        // not on product page

        const viewedProductData = JSON.parse(localStorage.getItem("recentlyViewedProduct"));

        if(viewedProductData && viewedProductData[0]){
          this.url = base_url + `&product_id=${viewedProductData[0].id}`
        } else {
        this.url = base_url + `&product_id=${this.dataset.backup}`
        }

      }

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
